/* eslint-disable no-underscore-dangle */
/* eslint-disable default-param-last */
import { Reducer } from 'redux';
import produce from 'immer';

import { AtaTypes, AtasState } from './types';

const INITIAL_STATE: AtasState = {
  atas: {
    ata: [],
    currentPage: 1,
    postsPerPage: 20,
    total_entries: 0,
    atas_status: '',
  },
  request: {
    loading: false,
    loaded: false,
    error: false,
  },
};

const reducer: Reducer<AtasState> = (state = INITIAL_STATE, { type, result, currentPage }) => {
  return produce(state, (draft) => {
    switch (type) {
      case AtaTypes.GET_ATAS_REQUEST:
        draft.request = {
          loading: true,
          loaded: false,
          error: false,
        };
        draft.atas = INITIAL_STATE.atas;
        break;
      case AtaTypes.GET_ATAS_SUCCESS:
        draft.atas.ata = result?.data?.atas;
        draft.atas.atas_status = result?.data?.atas_status;
        draft.atas.total_entries = result?.data?.total_rows;
        draft.request = {
          loading: false,
          loaded: true,
          error: false,
        };
        break;
      case AtaTypes.GET_ATAS_FAILURE:
        draft.atas = INITIAL_STATE.atas;
        draft.request = {
          loading: false,
          loaded: false,
          error: true,
        };
        break;
      case AtaTypes.SEARCH_ATAS_REQUEST:
        draft.request = {
          loading: true,
          loaded: false,
          error: false,
        };
        break;
      case AtaTypes.SEARCH_ATAS_SUCCESS:
        draft.atas.ata = result?.data?.atas;
        draft.atas.total_entries = result?.data?.total_rows;
        draft.request = {
          loading: false,
          loaded: true,
          error: false,
        };
        break;
      case AtaTypes.SEARCH_ATAS_FAILURE:
        draft.request = {
          loading: false,
          loaded: false,
          error: true,
        };
        break;
      case AtaTypes.UPDATE_CURRENT_PAGE:
        draft.atas.currentPage = currentPage;
        break;
      default:
        break;
    }
  });
};

export default reducer;
